import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Page } from '../../core/model/page';
import { VResponseBatchModule } from '../../core/model/v-response-batch.module';
import { FileDownloaderService } from '../../core/services/file-downloader.service';
import { InventariosService } from '../../core/services/inventarios.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-carga-inventarios',
  templateUrl: './carga-inventarios.component.html',
  styleUrls: ['./carga-inventarios.component.css']
})
export class CargaInventariosComponent implements OnInit {

  cargasInventario: VResponseBatchModule[] = [];
  loading = false;
  page = new Page();
  selectedRow: VResponseBatchModule;

  @ViewChild('tblcargas') table: any;

  constructor(
    private inventoryService: InventariosService,
    private toastr: ToastrService,
    private utilsService: UtilitiesService
  ) { }

  ngOnInit() {
    this.resetPagination();
    this.load();
  }

  resetPagination() {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  autorizar(idCarga: number, resultado: boolean) {
    this.loading = true;
    this.inventoryService.authInventario(idCarga, resultado)
      .subscribe(
        p => {
          this.loading = false;
          this.load();
          this.toastr.success('Se ha autorizado correctamente la carga de inventario');
        },
        () => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al autorizar la carga de inventario');
        });
  }

  setPage($event) {
    this.load($event.offset * $event.pageSize, $event.pageSize);
  }

  activateRow($event) {
    if ($event.type == 'click') {
      this.selectedRow = $event.row;
    }
  }

  onResized($event) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  load(desde: number = 0, cantidad: number = 10) {
    this.loading = true;
    this.inventoryService.getCargasInventario(desde, cantidad)
      .subscribe(
        (res) => {
          this.cargasInventario = res;
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.toastr.error('Ha ocurrido un error al recuperar las cargas de inventario');
        }
      );
  }

  descargarFicheroCarga(ficheros: string[]) {
    this.loading = true;
    ficheros.forEach(p => {
      this.inventoryService.downloadFicheroCarga(p)
        .subscribe(
          x => {
            this.utilsService.downloadGenericFile(p + '.xlsx', x);
            this.loading = false;
          },
          (errormsg: Error) => {
            this.toastr.error('Error al recuperar el fichero: ' + errormsg.message);
            this.loading = false;
          }
        );
    });
  }

}
